import axios from 'axios';
import moment from 'moment';
import hash from 'object-hash';
import { notification } from '../notifications';

import { API_HOST } from '../../constans/api';
import { STATUSES } from '../../constans/statuses-writes';
import { store } from '../../store';

export const SWITCH_LOADING_SCHEDULE = 'SWITCH_LOADING_SCHEDULE';
export const SWITCH_CREATE_POPUP = 'SWITCH_CREATE_POPUP';
export const RESET_DATA_SCHEDULE = 'RESET_DATA_SCHEDULE';
export const SET_CREATING_WRITE_SCHEDULE = 'SET_CREATING_WRITE_SCHEDULE';
export const UNSET_CREATING_WRITE_SCHEDULE = 'UNSET_CREATING_WRITE_SCHEDULE';
export const ADD_WRITE_SCHEDULE = 'ADD_WRITE_SCHEDULE';
export const CHANGE_TIME_SCHEDULE = 'CHANGE_TIME_SCHEDULE';
export const CHANGE_SCREEN_SCHEDULE = 'CHANGE_SCREEN_SCHEDULE';
export const TARIFF_END = 'TARIFF_END';

export const REQUEST_CREATE_WRITE_SCHEDULE = 'REQUEST_CREATE_WRITE_SCHEDULE';
export const RESPONSE_CREATE_WRITE_SCHEDULE = 'RESPONSE_CREATE_WRITE_SCHEDULE';

export const REQUEST_FILTERS_PARAMS = 'REQUEST_FILTERS_PARAMS';
export const RESPONSE_FILTERS_PARAMS = 'RESPONSE_FILTERS_PARAMS';
export const REQUEST_SETTINGS = 'REQUEST_SETTINGS';
export const RESPONSE_SETTINGS = 'RESPONSE_SETTINGS';

export const REQUEST_CONFIRM_PHONE_SEND = 'REQUEST_CONFIRM_PHONE_SEND';
export const RESPONSE_CONFIRM_PHONE_SEND = 'RESPONSE_CONFIRM_PHONE_SEND';
export const REQUEST_CONFIRM_PHONE_CHECK = 'REQUEST_CONFIRM_PHONE_CHECK';
export const RESPONSE_CONFIRM_PHONE_CHECK = 'RESPONSE_CONFIRM_PHONE_CHECK';

export const SET_SCHEDULE = 'SET_SCHEDULE';
export const REQUEST_GET_SCHEDULE = 'REQUEST_GET_SCHEDULE';
export const RESPONSE_GET_SCHEDULE = 'RESPONSE_GET_SCHEDULE';
export const RESPONSE_UPDATE_SCHEDULE = 'RESPONSE_UPDATE_SCHEDULE';

const { token } = window.vpriemScheduleParams;

// SCHEDULE ACTIONS //

export const getScheduleAction = (filter, update = false) => (dispatch) => {
    const {
        date,
        speciality,
        filial,
        typeView,
        doctor
    } = filter;

    if (!update) {
        dispatch({ type: REQUEST_GET_SCHEDULE });

        // clear intervals before request with new filters
        if (localStorage.getItem('scheduleUpdateInterval')) {
            const ticketsIntervals = JSON.parse(localStorage.getItem('scheduleUpdateInterval'));
            ticketsIntervals.forEach(ticketsInterval => clearInterval(+ticketsInterval));
            localStorage.setItem('scheduleUpdateInterval', JSON.stringify([]));
        }
    }

    const requestParams = new URLSearchParams({
        currentDate: date.format('x'),
        services: speciality && speciality.value !== 0 ? speciality.value : '',
        filial: filial && filial.value !== 0 ? filial.value : '',
        typeView: typeView.value,
        workers: doctor && doctor.value !== 0 ? doctor.value : '',
        token,
    });

    axios.get(`${API_HOST}tickets?${requestParams.toString()}`)
    .then((response) => {
        const { data } = response;
        if (!+data.error) {
            if (update) {
                dispatch({
                    type: RESPONSE_UPDATE_SCHEDULE,
                    payload: data.data
                });
            } else {
                dispatch({
                    type: RESPONSE_GET_SCHEDULE,
                    payload: data.data
                });
            }
        } else {
            dispatch({ type: RESPONSE_GET_SCHEDULE, payload: [] });
            notification('error', 'Произошла ошибка при получении расписания');
            console.error(data.message);
        }
    })
    .catch((error) => {
        dispatch({ type: RESPONSE_GET_SCHEDULE, payload: [] });
        notification('error', 'Произошла ошибка при получении расписания');
        console.error(error);
    });
};

export const resetDataScheduleAction = () => (dispatch) => {
    // clear intervals before request with new filters
    if (localStorage.getItem('scheduleUpdateInterval')) {
        const ticketsIntervals = JSON.parse(localStorage.getItem('scheduleUpdateInterval'));
        ticketsIntervals.forEach(ticketsInterval => clearInterval(+ticketsInterval));
        localStorage.setItem('scheduleUpdateInterval', JSON.stringify([]));
    }

    dispatch({ type: RESET_DATA_SCHEDULE });
};

// SCHEDULE ACTIONS END //

export const changeTimeAction = () => (dispatch) => {
    const time = moment();
    dispatch({ type: CHANGE_TIME_SCHEDULE, payload: { time } });
};

export const getFiltersParamsAction = () => (dispatch) => {
    dispatch({ type: REQUEST_FILTERS_PARAMS });

    axios.all([
        axios.get(`${API_HOST}dictionary/filials?token=${window.vpriemScheduleParams.token}`),
        axios.get(`${API_HOST}dictionary/services?token=${window.vpriemScheduleParams.token}`),
        axios.get(`${API_HOST}dictionary/workers?token=${window.vpriemScheduleParams.token}`)
    ])
     .then(axios.spread((filialsResponse, servicesResponse, workersResponse) => {
        const { data: dataFilials } = filialsResponse;
        const { data: dataServices } = servicesResponse;
        const { data: dataWorkers } = workersResponse;

        if (!+dataFilials.error && !+dataServices.error && !+dataWorkers.error) {
            dispatch({
                type: RESPONSE_FILTERS_PARAMS,
                payload: {
                    filials: dataFilials.data,
                    services: dataServices.data,
                    workers: dataWorkers.data.filter(worker => +worker.type_id === 2)
                }
            });
        } else {
            dispatch({ type: RESPONSE_FILTERS_PARAMS, payload: null });
            console.error(dataFilials.message, dataServices.message);
        }
     }))
     .catch((error) => {
        dispatch({ type: RESPONSE_FILTERS_PARAMS, payload: null });
        console.error(error);
     });
};

export const switchPopupCreateAction = () => (dispatch) => {
    dispatch({ type: SWITCH_CREATE_POPUP });
};

export const createWriteAction = (fields, ticket) => (dispatch) => {
    dispatch({ type: REQUEST_CREATE_WRITE_SCHEDULE });

    const formData = new FormData();
    const sendData = {
        ticket_id: +ticket.id,
        status: STATUSES.unconfirmed.value,
        recorded_user_id: 0,
        recorded_from_site: 1,
        doctor_worker_id: +ticket.worker_id,
        filial_id: +ticket.filial_id,
        patient_last_name: fields['last-name'],
        patient_first_name: fields['first-name'],
        patient_second_name: fields['second-name'],
        patient_phone: fields.phone,
        patient_birthday: Object().hasOwnProperty.call(fields, 'birthday') ? +moment(fields.birthday).format('x') : +moment().format('x'),
        patient_type_payment: +fields['payment-type'].value,
        patient_type_reception: 1,
        patient_comment: fields.comments ? fields.comments : '',
        patient_representative: fields.representative ? fields.representative : '',
        token
    };

    for (const key in sendData) {
        if ({}.hasOwnProperty.call(sendData, key)) {
            formData.append(key, sendData[key] !== undefined ? sendData[key] : '');
        }
    }

    axios.post(`${API_HOST}writes`, formData)
    .then((response) => {
        const { data } = response;

        dispatch({ type: RESPONSE_CREATE_WRITE_SCHEDULE });

        if (!+data.error) {
            dispatch({
                type: ADD_WRITE_SCHEDULE,
                payload: data.data
            });

            notification('success', 'Вы успешно записаны');
        } else {
            console.error(data.message);
            notification('error', 'Произошла ошибка при создании записи');
        }
    })
    .catch((error) => {
        dispatch({ type: RESPONSE_CREATE_WRITE_SCHEDULE });
        notification('error', 'Произошла ошибка при создании записи');
        console.error(error);
    });
};

export const setCreatingWriteAction = (type, ticket) => (dispatch) => {
    switch (type) {
        case 'SET': {
            const formData = new FormData();
            formData.append('id', ticket.id);
            formData.append('token', token);

            localStorage.setItem('edit_ticket_id', ticket.id);

            axios.post(`${API_HOST}tickets/setEditing`, formData);

            dispatch({ type: SET_CREATING_WRITE_SCHEDULE, payload: { type, ticket } });

            break;
        }
        case 'UNSET': {
            const formData = new FormData();
            formData.append('id', ticket.id);
            formData.append('token', token);

            localStorage.removeItem('edit_ticket_id');

            axios.post(`${API_HOST}tickets/unsetEditing`, formData);

            dispatch({ type: UNSET_CREATING_WRITE_SCHEDULE, payload: { type, ticket } });

            break;
        }
        default:
            break;
    }
};

export const changeScreenAction = (screen, data = null) => (dispatch) => {
    dispatch({ type: CHANGE_SCREEN_SCHEDULE, payload: { screen, data } });
};

export const getSettingsAction = () => (dispatch) => {
    dispatch({ type: REQUEST_SETTINGS });

    axios.get(`${API_HOST}settings?token=${window.vpriemScheduleParams.token}`)
    .then((response) => {
        if (!response.data.error) {
            dispatch({ type: RESPONSE_SETTINGS, payload: response.data.data });
        } else {
            dispatch({ type: RESPONSE_SETTINGS, payload: null });
        }
    })
    .catch((error) => {
        dispatch({ type: RESPONSE_SETTINGS, payload: null });
        console.error(error);
    });
};

export const confirmPhoneSend = phone => (dispatch) => {
    dispatch({ type: REQUEST_CONFIRM_PHONE_SEND });

    const formData = new FormData();
    formData.append('phone', phone);
    formData.append('token', window.vpriemScheduleParams.token);

    axios.post(`${API_HOST}writes/confirmPhone`, formData)
    .then((response) => {
        dispatch({ type: RESPONSE_CONFIRM_PHONE_SEND, payload: response.data.error });
    })
    .catch((error) => {
        dispatch({ type: RESPONSE_CONFIRM_PHONE_SEND, payload: 1 });
        console.error(error);
    });
};

export const confirmPhoneCheck = (code, phone) => (dispatch) => {
    dispatch({ type: REQUEST_CONFIRM_PHONE_CHECK });

    const token = window.vpriemScheduleParams.token;

    axios.get(`${API_HOST}writes/confirmPhone?phone=${phone}&code=${code}&token=${token}`)
    .then((response) => {
        dispatch({ type: RESPONSE_CONFIRM_PHONE_CHECK, payload: response.data.error });
    })
    .catch((error) => {
        dispatch({ type: RESPONSE_CONFIRM_PHONE_CHECK, payload: 1 });
        console.error(error);
    });
};
